import {EventInput} from '@fullcalendar/core';
import {marker} from "@biesbjerg/ngx-translate-extract-marker";

export interface IOutOfOffice {
  id: number;
  description: string;
  displayName: string;
  startDate: number[];
  endDate: number[];
  userId: number;
  userName: string;
  firstName: string;
  lastName: string;
  outOfOfficeTypeId: number;
  outOfOfficeType: string;
  countTowardsContribution: boolean;
}

export interface IOutOfOfficeType {
  id: number;
  description: string;
  name: string;
  createdBy: string;
  countsTowardsContribution: boolean;
  createdOn: string;
}

export interface IStoreVisitEventType {
  id: number;
  storeVisitEventType: string;
  priority: number;
  eventColorCode: string;
}
export interface IScheduledVisit {
  storeId: number;
  storeName?: string;
  storeNickname?: string;
  startTime: number;
  endTime: number;
  storeVisitEventTypeId: number;
  storeVisitEventType?: string;
  notes?: string;
  groupId?: number;
  groupName?: string;
  id?: number;
  ownStoreFlag?: boolean;
  timeZoneJavaId?: string;
}

export enum MICalendarEventTypesEnum {
  StoreVisitsEvent = 1,
  Job = 2,
  OutOfOfficeEvent = 3,
  EndPointSchedule = 4,
}

export interface MICalendarEvent extends EventInput {
  eventId: number;
  eventType: number;
  storeVisitDetails?: any;
  jobDetails?: any;
  oooDetails?: any;
  endPointScheduleDetails?: any;
}

export interface ICalendarData {
  viewType: string;
  currentDate?: string;
  user?: any;
  startDate?: string;
  endDate?: string;
  store?: any;
  accountIds?: number[];
  jobStatus?: string[];
  includeCompletedJobs?: boolean;
}
export interface ICalendarFilters {
  jobs: string;
  outOfOffice: string;
  vibaSchedules: string;
  visits: string;
  urlParams?: string;
}
export interface ICalendarEventType {
  id?: number;
  eventType: string;
  eventColorCode: string;
  calendarEventTypeCategoryId: number;
  calendarEventTypeCategory?: string;
  priority: number;
  storeVisitEventType: string;
  countTowardsContribution?: boolean;
  description?: string;
}

// translation support
const calendarEventTypesTranslateMarkers = [
  marker('Activity Status'),
  marker('Out Of Office'),
  marker('Store Visit'),
];
export enum CalendarEventTypeCategory {
  ACTIVITY_STATUS = 'Activity Status',
  OUT_OF_OFFICE = 'Out Of Office',
  STORE_VISIT_EVENT_TYPE = 'Store Visit'
}
